(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CookieInfo", [], factory);
	else if(typeof exports === 'object')
		exports["CookieInfo"] = factory();
	else
		root["CookieInfo"] = factory();
})(this, () => {
return 